// extracted by mini-css-extract-plugin
export default {"container":"ClickableCard_container__UJblR"};